import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TransalteLangugaeService implements TranslateLoader{
  public defaultLang = 'en';

  constructor(private http: HttpClient,private translate: TranslateService) {}
  private langSubject = new BehaviorSubject<any>(this.getCurrentLang());
  lang$ = this.langSubject.asObservable();

  // Fetch translations for a specific language code
  getTranslation(lang): Observable<any> {
    return this.http.get<any>('assets/i18n/language.json').pipe(
      map((data) => {
        const langObj = data.find((item) => item.code === lang);
        return langObj?.translations || {};
      })
    );
  }

  // Get all language metadata
  getAllLanguages(): Observable<any> {
    return this.http.get<any>('assets/i18n/language.json');
  }

  // Set and use language
  switchLanguage(lang): void {
    this.getTranslation(lang).subscribe((translations) => {
      this.translate.setTranslation(lang, translations, true);
      this.translate.use(lang);
    });
  }

  // Get current language from localStorage or default
  getCurrentLang(): string {
    return localStorage.getItem('lang') || this.defaultLang;
  }

  // Save selected language
  setCurrentLang(lang: string): void {
    localStorage.setItem('lang', lang);
    this.langSubject.next(lang);
  }
}